import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getAllIntegrationItemGroups = (
    token: string,
    backend: string,
) => {
    return fetch(
        `${getApiUrl(backend)}get_all_integrationItemGroups`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getAllIntegrationItemGroups;
